<template>
  <div style="padding: 0% 0px 1%;">
    <div class="titleTable">{{ text }}</div>
    <div class="cardTable">
      <v-data-table :headers="headers" :items="items" hide-actions>
        <template v-slot:items="props">
          <td class="text-code">{{ props.item.name }}</td>
          <td class="text-content">{{ props.item.values }}</td>
        </template>
      </v-data-table>
    </div>
    <div class="text-footer-table">{{ notes }}</div>
  </div>
</template>

<script>
  export default {
    name: 'DomainTable',
    props: {
      items: {
        type: Array,
        default: []
      },
      notes: {
        type: String
      },
      text: {
        type: String
      }
    },
    data(){
      return {
        headers: [
          { text: 'Property', value: 'property', align: 'left', sortable: false },
          { text: 'Content', value: 'content', align: 'left', sortable: false }
        ]
      }
    }
  }
</script>

<style scoped>
.cardTable {
  background-color: #2e4369;
  border-radius: 05px;
  padding: 0px 0x 0px 0px;
  box-shadow: 0px 0px 1px;
}

.titleTable {
  font-family: 'Paralucent';
  font-weight: 500;
  font-size: 14px;
  padding: 10px 0px;
  color: #2e4369;
}

.text-code {
  font-family: 'Courier New', Courier, monospace;
}

.text-content {
  font-family: 'Paralucent';
  font-size: 12px;
  padding: 10px 0px;
  color: #2e4369;
}

.v-chip.fixed-chip {
  border-radius: 2px;
}

.text-footer-table {
  font-family: 'Paralucent';
  font-size: 12px;
  margin: 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/documentation/DomainTable.vue